import styles from "./../buttons.module.scss"
import React from "react";
import classNames from "classnames";
import {getBaseClassName} from "./Button";
import Tooltip from "./Tooltip";

let Link = null;

export const setLinkProvider = ({Link: _Link}) => {
    Link = _Link;
}

export const StyledLink = ({children, className, style, color, type, variant, large, disabled, tooltip, to, onClick, ...rest}) => {
    const baseClassName = getBaseClassName({type, color, variant})

    const _className = classNames(baseClassName, className, {[styles.large]: large});
    return <Link onClick={disabled ? e => {e.preventDefault()} : onClick} disabled={disabled} className={_className} {...rest} to={disabled ? "" : to} style={style}>
        {children}
        {tooltip && <Tooltip>{tooltip}</Tooltip>}
    </Link>
}
